import listActions from 'src/modules/objective/list/objectiveListActions';
import ObjectiveService from 'src/modules/objective/objectiveService';
import Errors from 'src/modules/shared/error/errors';
import { i18n } from 'src/i18n';
import { getHistory } from 'src/modules/store';
import Message from 'src/view/shared/message';

const prefix = 'OBJECTIVE_DESTROY';

const objectiveDestroyActions = {
  DESTROY_STARTED: `${prefix}_DESTROY_STARTED`,
  DESTROY_SUCCESS: `${prefix}_DESTROY_SUCCESS`,
  DESTROY_ERROR: `${prefix}_DESTROY_ERROR`,

  DESTROY_ALL_STARTED: `${prefix}_DESTROY_ALL_STARTED`,
  DESTROY_ALL_SUCCESS: `${prefix}_DESTROY_ALL_SUCCESS`,
  DESTROY_ALL_ERROR: `${prefix}_DESTROY_ALL_ERROR`,

  doDestroy: (id) => async (dispatch) => {
    try {
      dispatch({
        type: objectiveDestroyActions.DESTROY_STARTED,
      });

      await ObjectiveService.destroyAll([id]);

      dispatch({
        type: objectiveDestroyActions.DESTROY_SUCCESS,
      });

      Message.success(
        i18n('entities.objective.destroy.success'),
      );

      dispatch(listActions.doFetchCurrentFilter());

      getHistory().push('/objective');
    } catch (error) {
      Errors.handle(error);

      dispatch(listActions.doFetchCurrentFilter());

      dispatch({
        type: objectiveDestroyActions.DESTROY_ERROR,
      });
    }
  },

  doDestroyAll: (ids) => async (dispatch) => {
    try {
      dispatch({
        type: objectiveDestroyActions.DESTROY_ALL_STARTED,
      });

      await ObjectiveService.destroyAll(ids);

      dispatch({
        type: objectiveDestroyActions.DESTROY_ALL_SUCCESS,
      });

      if (listActions) {
        dispatch(listActions.doChangeSelected([]));
        dispatch(listActions.doFetchCurrentFilter());
      }

      Message.success(
        i18n('entities.objective.destroyAll.success'),
      );

      getHistory().push('/objective');
    } catch (error) {
      Errors.handle(error);

      dispatch(listActions.doFetchCurrentFilter());

      dispatch({
        type: objectiveDestroyActions.DESTROY_ALL_ERROR,
      });
    }
  },
};

export default objectiveDestroyActions;
